<template>
  <div class="account-selector" v-if="shouldShow">
    <div class="display-name">
      {{displayName}}
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    name: 'account-selector',
    data () {
      return {}
    },
    computed: {
      ...mapGetters('auth', ['isLogged']),
      ...mapState(['currentDestinyAccount']),
      displayName () {
        return this.$store.state.currentDestinyMembership.displayName
      },
      shouldShow () {
        return this.isLogged &&
          this.$store.state.currentDestinyAccount &&
          this.$store.state.currentDestinyAccount &&
          this.$store.state.destinyAccounts.length > 1
      }
    },
    methods: mapActions(['login'])
  }
</script>

<style scoped>
  .account-selector {
    display: flex;
    flex-direction: row;
  }

  .destiny-picture {
    padding: .25rem 0.5rem 0 1rem;
  }

  .destiny-picture img {
    height: 2.5rem;
  }

  .display-name {
    padding: 1rem 0.5rem;
  }

</style>



// WEBPACK FOOTER //
// AccountSelector.vue?70d58bb6